<template>
	<div class="container">
		<breadcrumbs
			class="breadcrumbs ar"
			:links="[
              { name: 'الرئيسية', link: {name: 'home'} },
              { name: 'السلاسل', link: {}, active: true },
            ]"
		></breadcrumbs>
		<div class="top">
			<div class="title">السلاسل</div>
		</div>

		<loader v-if="loadingSeriesAndVolumes" height="40vh" class="mb-5"/>
		<div v-else class="main">
			<series-card
			  v-for="serie in series"
			  :key="serie.id"
			  :serie="serie"
			/>
		</div>
	</div>
</template>

<script>
import SeriesCard from '@/components/SeriesCard';
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import { mapState } from 'vuex';
export default {
	props:['loadingSeriesAndVolumes'],

	components: {
		SeriesCard,
		Breadcrumbs,
		Loader
	},

	computed:{
		...mapState({
			series: state => state.series.series
		})
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > .top , .container > .main, .container > .breadcrumbs {
	margin: 0 50px;
}
.main {
	padding: 20px 0 50px;
	display: grid;
	grid-template-columns: repeat(3, minmax(min-content, 333px));
	justify-content: center;
	row-gap: 20px;
	column-gap: 30px;
}
.top {
	text-align: center;
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
}
@media only screen and (max-width: 992px) {
	.main {
		grid-template-columns: repeat(auto-fit, 250px);
		column-gap: 20px;
	}
	.container > * {
		margin: 0 10px;
	}
}
@media only screen and (max-width: 890px) and (min-width: 620px){
	.main div:last-child {
		grid-column-start: 1;
		grid-column-end: 3;
		margin: auto;
		width: 50%;
	}
}
</style>
